import ClaimTaskDialog from "../../ClaimTaskDialog/ClaimTaskDialog";
import { Notification } from "@progress/kendo-react-notification";
import { Container, HBox, PuzzleButton } from "puzzle";
import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import { GridColumn as KendoGridColumn } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { STATE } from "../../../Abstract/ClaimDialog/Types";
import { CLAIM_OFFER_PROPS, PREVIEW_ITEM } from "../Types";
import _ from "lodash";

class ClaimOfferDialog extends ClaimTaskDialog<CLAIM_OFFER_PROPS, STATE> {

  moduleDidMount = () => {
    const {
      claimLvl,
      previewData
    } = this.props.offerClaimDialogData;

    this.setState({
      claimLvl,
      data: previewData
    })
  };

  /**
   * @override
   */
  isCellDisabled = (cellProps: GridCellProps): string => {
    const { dataItem } = cellProps;
    return dataItem.offerStatus !== 'decline' ? '' : 'tp-state-disabled';
  };

  /**
   * @override
   */
  isWordCountClickable = () => false;

  /**
   * @override
   */
  getCellRender = (cellProps: GridCellProps, field: string, dataItem: any) => {
    let render = super.getCellRender(cellProps, field, dataItem);
    if (render === dataItem[field])
      switch (cellProps.field) {
        case 'total':
          render = this.offerCellRender(cellProps);
          break;
        case 'offerStatus':
          render = this.offerStatusCellRender(cellProps);
          break;
        default:
          render = dataItem[field];
          break;
      }

    return render;
  };

  /**
   * @override
   */
  renderFooterButtons = (): JSX.Element => {
    const {
      postData: offerDialogPost,
      submissionData
    } = this.props.offerClaimDialogData

    return <>
      <Notification
        className={'tp-informational'}
        type={{ style: 'warning', icon: true }}
      >
        {this.translate('warningBadge')}
      </Notification>
      <Container className={'k-flex-1'} />
      <PuzzleButton
        onClick={() => this.dispatch('closeOfferClaim')}
        fillMode={'flat'}>
        {this.translate('cancel')}
      </PuzzleButton>
      <PuzzleButton
        themeColor={'primary'}
        onClick={() => this.dispatch('submitOfferClaim', '', {
          offerDialogPost,
          offerRequestUrl: `/jobPhase/${submissionData.submissionId}/offer`
        })}
      >
        {this.translate('submit')}
      </PuzzleButton>
    </>
  };

  /**
   * Offer cell render
   */
  offerCellRender = (cellProps: GridCellProps): JSX.Element => {
    const { dataItem } = cellProps;
    const { total } = dataItem;
    let text = '-';
    if (_.isNumber(total)) {
      text = `${this.props.offerClaimDialogData.currency} ${total.toFixed(this.props.offerClaimDialogData.roundingDigits)}`;
    }

    return (
      <span className="tp-dialog-claim-phases-status-cell not-claimed">
        {text}
      </span>
    )
  };

  /**
   * Offer status cell render
   */
  offerStatusCellRender = (cellProps: GridCellProps): JSX.Element => {
    const { dataItem } = cellProps;
    const { offerStatus } = dataItem;
    let text = "";
    let className;

    switch (offerStatus) {
      case 'accept':
        text = this.translate('status.accepted');
        className = 'tp-check-circle';
        if (dataItem.cva) {
          text = this.translate('status.sent');
          className = 'tp-arrow-left-circle-filled'
        }
        break;
      case 'decline':
        className = 'tp-close-circle';
        text = this.translate('status.declined');
        break;
      case 'negotiate':
        className = 'tp-arrow-left-circle-filled';
        text = this.translate('status.counterOfferSent');
        break;
      default:
        break;
    }

    return (
      <HBox
        alignItemsCenter
        className={'pd-offer-status-cell tp-text-semibold'}
        gap={1}
        htmlTag={'span'}
      >
        <i aria-hidden={true} className={`tp-icon ${className}`} />
        <span>{text}</span>
      </HBox>
    )
  };

  /**
   * Adds additional columns
   */
  renderColumns = () => {
    let columns = super.renderColumns();
    const columnCommonProps: any = {
      minResizableWidth: 100,
      className: 'tp-sortable k-text-right',
      headerClassName: 'tp-sortable'
    };

    columns.splice(3, 1);
    columns.push(
      <KendoGridColumn
        key={"total_key"}
        field="total"
        title={this.translate('columnHeaders.total')}
        width="210px"
        {...columnCommonProps}
      />,
      <KendoGridColumn
        key={"offerStatus_key"}
        field="offerStatus"
        width="238px"
        title={this.translate('columnHeaders.offerStatus')}
        {...columnCommonProps}
      />
    )

    return columns;
  }

}

export default ClaimOfferDialog;
